const panel = document.getElementById('panel');
const panelPicture = document.getElementById('team-key-visual');
const panelName = document.getElementById('team-name');
const panelPosition = document.getElementById('team-position');
const panelBody = document.getElementById('team-body');
const panelLinkedIn = document.getElementById('team-linkedin');
const language = document.querySelector('html').getAttribute('lang');

const btnProfileNext = document.querySelector('.panel .btn[data-action="profile-next"]');
const btnProfilePrev = document.querySelector('.panel .btn[data-action="profile-previous"]');

let profilePrev = ()=>{}
let profileNext = ()=>{};

btnProfilePrev.addEventListener('click', () =>{
  profilePrev();
})

btnProfileNext.addEventListener('click', () =>{
  profileNext();
})

document.querySelectorAll('a.item').forEach(el => {
  el.addEventListener('click', evt => {
    evt.preventDefault();
    const pageId = el.getAttribute('data-team-id');

    if(el.previousElementSibling){
      btnProfilePrev.classList.remove('disabled');
      profilePrev = ()=>el.previousElementSibling.click();
    }else{
      btnProfilePrev.classList.add('disabled');
    }

    if(el.nextElementSibling){
      btnProfileNext.classList.remove('disabled');
      profileNext = ()=>el.nextElementSibling.click();
    }else{
      btnProfileNext.classList.add('disabled');
    }

    panelPicture.style.backgroundImage = el.querySelector('.picture').style.backgroundImage;
    panelName.innerHTML = el.querySelector('.caption .name').innerHTML;
    panelPosition.innerHTML = el.querySelector('.caption .position').innerHTML;
//fetch
    panelBody.innerHTML = "loading...";
    fetch(`/${language}/api/teams/${pageId}`).then(response => response.json().then(obj =>{
      panelBody.innerHTML = obj.payload.body || "&nbsp;";
      panelLinkedIn.setAttribute('href', obj.payload.linkedin);
    }))


    panel.classList.add('active');
  })
})